module.exports = __webpack_public_path__ + "img/equinix.439fbbbe.svg";